import type { FC } from "react";
import { useEffect } from "react";

import Carousel from "@/design-system/carousel";
import { sendTelemetryEvent } from "@/lib/telemetry";
import { useViewportInfoContext } from "@/src/contexts";
import useAjax from "@Components/Hooks/useAjax";
import DiscountTileV3, {
    DiscountTypeEnum,
    type IDiscountTileV3,
} from "@Components/discount-tile/discount-tile-v3";
import type { QueryXsMax } from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export interface IDiscountsSection {
    initialData: IDiscountTileV3[];
    ajaxAction?: string;
}

const DiscountsSection: FC<IDiscountsSection> = ({
    initialData = Array.from<IDiscountTileV3>({ length: 3 }),
    ajaxAction,
}) => {
    const { isMobile, isDesktop } = useViewportInfoContext();

    const { data, request } = useAjax({ initialData, ajaxAction });

    useEffect(() => {
        if (!data) request();
    }, []);

    const clickTelemetryEvent = () => {
        sendTelemetryEvent({
            actionType: "Swipe",
            eventName: "homepg-discountSwipe",
        });
    };
    return (
        <div {...stylex.props(styles.carouselContainer)}>
            <Carousel
                showArrows={!isMobile}
                itemsToShow={isDesktop ? 3 : isMobile ? 1.1 : 2}
                styleX={styles.carousel}
                onNextClick={clickTelemetryEvent}
                onPrevClick={clickTelemetryEvent}
            >
                {data?.map((item: IDiscountTileV3, index: number) => (
                    <DiscountTileV3
                        key={(item && item.id) || index}
                        {...item}
                        discountType={item.discountType ?? DiscountTypeEnum.Promotion}
                        styleX={styles.discount}
                    />
                ))}
            </Carousel>
        </div>
    );
};
const xsMax: QueryXsMax = "@media (max-width: 759px)";

const styles = stylex.create({
    // this is ugly, but changing discounttilev2 can cause breaking changes
    discount: {
        position: "relative",
    },
    carouselContainer: {
        margin: {
            default: null,
            [xsMax]: "0 -10px",
        },
    },
    carousel: {
        padding: { default: null, [xsMax]: "0 10px" },
        scrollSnapType: { default: "x mandatory", [xsMax]: "unset" },
    },
});

export default DiscountsSection;
